import React, { useEffect, useState } from "react";
import { usePermissions } from "../../common/PermissionContext";
// Components
import Geography from "../Geography/geoTabs";
import BloodGroup from "../Dropdowns/BloodGroup";
import AlcoholUsage from "../Dropdowns/AlcoholUsage";
import TobaccoUsage from "../Dropdowns/TobaccoUsage";
import AccountType from "../AccountType/AccountType";
import Gender from "../Competition/Competition Settings/Gender";
import Countries from "../Competition/Competition Settings/Countries";

const GeneralSettings = () => {
    const { getSubSubMenus } = usePermissions();
    const subSubMenus = getSubSubMenus("General Setting");
    const [activeTab, setActiveTab] = useState("");

    const componentMap: Record<string, React.ReactNode> = {
        "Geography": <Geography />,
        "Blood Group": <BloodGroup />,
        "Alcohol Usage": <AlcoholUsage />,
        "Tobacco Usage": <TobaccoUsage />,
        "Account Type": <AccountType />,
        "Gender": <Gender />,
        "Countries": <Countries />,
    };


    const tabData = subSubMenus
        .filter((menu: any) =>
            menu.permissions
                ?.split(",")
                .map((permission: string) => permission.trim())
                .includes("view")
        )
        .map((menu: any) => {

            const title = menu.title.trim();

            return {
                name: title,
                route: menu.route,
                icon: <i className="fas fa-cog" />,
                content: componentMap[title] || (
                    <div>
                        No component configured for {title}
                    </div>
                ),
            };
        });

    useEffect(() => {
        if (tabData.length > 0) {
            setActiveTab((currentTab) => {
                const stillExists = tabData.some(
                    (tab) => tab.name === currentTab
                );
                return stillExists
                    ? currentTab
                    : tabData[0].name;
            });

        } else {
            setActiveTab("");
        }
    }, [subSubMenus]);

    return (
        <div className="content container" style={{ maxWidth: "1500px" }}>
            <div className="sortby-section">
                <div className="sorting-info">
                    <div className="row">
                        {/* LEFT SIDE - TABS */}
                        <div className="col-lg-2">
                            <ul className="list-group">
                                {tabData.map((tab, i) => (
                                    <li
                                        key={i}
                                        className={`list-group-item ${activeTab === tab.name ? "active" : ""}`}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setActiveTab(tab.name)}
                                    >
                                        {tab.name?.replaceAll("_", " ").toUpperCase()}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* RIGHT SIDE - CONTENT */}
                        <div className="col-lg-10">
                            {tabData.filter((tab) => tab.name === activeTab).map((tab, i) => (
                                <div key={i}>
                                    {tab.content}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GeneralSettings;